module.exports = __webpack_public_path__ + "img/makiimsetoben.c3dd1763.jpg";